module.exports = __webpack_public_path__ + "static/media/empty_transactions.32a4e16f.png";